var map = {
	"./0-top.vue": 95344,
	"./1-top_kv.vue": 13223,
	"./2-top_sidebar.vue": 95060,
	"./20-beauty_3d.vue": 46943,
	"./21-beauty_3d.vue": 53344,
	"./30-beauty_alive.vue": 4434,
	"./40-beauty.vue": 77038,
	"./50-zhi.vue": 11333,
	"./54-voice.vue": 32374,
	"./58-assistant.vue": 14784,
	"./60-new.vue": 55014,
	"./62-aiplaygroud.vue": 89925,
	"./70-last.vue": 27732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31792;